// WORKSPACE APIS
import { createApi } from "@reduxjs/toolkit/query/react";

import { createInfiniteQuery } from "./infiniteQuery";

import { REQUEST_METHODS } from "@/constants/global-constants";
import { IWorkspace } from "@/interfaces/workspace.interface";
import { TWorkspaceSchema } from "@/schemas/workforce.schema";
import { BaseWithAuth } from "@/utils/helpers";

export const workspaceApi = createApi({
  reducerPath: "workspaceApi",
  baseQuery: BaseWithAuth(),
  tagTypes: ["workspace", "singleWorkspace"],
  endpoints: (builder) => ({
    // get single workspace
    getSingleWorkspace: builder.query<IWorkspace, string>({
      query: (subdomain) => `/general/workspace/${subdomain}`,
      providesTags: ["singleWorkspace"],
      transformResponse: (response: APIResponse<IWorkspace>) => response?.data,
    }),

    // get list of workspaces
    getWorkspaces: builder.query<GeneralResponse<IWorkspace[]>, string>({
      query: (filter) => `/superadmin/workspace${filter}`,
      providesTags: ["workspace"],
      // transformResponse: (response: APIResponse<IWorkspace[]>) =>
      //   response?.data,
    }),

    getInfiniteWorkspaces: createInfiniteQuery<IWorkspace[]>(
      builder,
      "/superadmin/workspace",
      ["workspace"],
    ),
    // add workspace
    addWorkspace: builder.mutation<TWorkspaceSchema, object>({
      query: (data) => ({
        url: "/superadmin/workspace",
        method: REQUEST_METHODS.POST,
        body: data,
      }),
      invalidatesTags: ["workspace"],
    }),

    // alter workspace
    alterWorkspace: builder.mutation<
      object,
      {
        id: string;
        data: object;
      }
    >({
      query: ({ data, id }) => ({
        url: `/superadmin/workspace/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["workspace", "singleWorkspace"],
    }),
  }),
});

export const {
  useGetSingleWorkspaceQuery,
  useGetWorkspacesQuery,
  useAddWorkspaceMutation,
  useAlterWorkspaceMutation,
  useGetInfiniteWorkspacesInfiniteQuery,
} = workspaceApi;

export type WorkspaceApiType = typeof workspaceApi;
